import { Box, Button, Typography } from "@mui/material";
import React from "react";
import { Link } from "react-router-dom";
import InventoryOutlinedIcon from "@mui/icons-material/InventoryOutlined";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import GroupAddOutlinedIcon from "@mui/icons-material/GroupAddOutlined";

const Navbar = () => {
  return (
    <Box
      sx={{
        position: "fixed",
        bottom: 0,
        width: "100%",
        display: "flex",
        justifyContent: "space-around",
        borderRadius: "32px 32px 0px 0px",
        background: "#C9B200",
        zIndex: 200,
      }}
    >
      <Link to={"/dashboard/my-surveys"}>
        <Button sx={{margin: '10px 0 !important'}}>
          <Box sx={{color: '#fff'}}>
            <InventoryOutlinedIcon fontSize="large" />
            <Typography fontSize={'12px'}>Surveys<br/>Taken</Typography>
          </Box>
        </Button>
      </Link>
      <Link to={"/dashboard"}>
        <Button sx={{margin: '10px 0 !important'}}>
          <Box sx={{color: '#fff'}}>
            <HomeOutlinedIcon fontSize="large" />
            <Typography fontSize={'12px'}>Home</Typography>
          </Box>
        </Button>
      </Link>
      <Link to={"/dashboard/invite"}>
        <Button sx={{margin: '10px 0 !important'}}>
          <Box sx={{color: '#fff'}}>
            <GroupAddOutlinedIcon fontSize="large" />
            <Typography fontSize={'12px'}>Invite</Typography>
          </Box>
        </Button>
      </Link>
    </Box>
  );
};

export default Navbar;
